<template lang="pug">

v-app-bar(
  clipped-left
  app
  height="calculateHeight"
  flat
  fixed
  class="app-bar"
)

  div(class="tablet-header" v-if="checkIfIsTablet")
    router-link(class="logo-container" :to="{ name: logoRouteName }")
      LefebvreLogoComponent

    AppBarToolbarItemsComponent

  div(class="app-bar-content" v-else)

    router-link(v-if="!checkIfIsTablet" class="logo-container" :to="{ name: logoRouteName }")
      LefebvreLogoComponent

    v-spacer

    div(v-if="showSearchSection" class="search-section")
      LexonSearchFieldComponent(
        @searchTerm="onSearchTerm"
      )

    AppBarToolbarItemsComponent

</template>

<script lang="ts">
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { URLS } from '@/router/routes/urlRoutes'
import AppBarToolbarItemsComponent from '@/components/Navigation/AppBarToolbarItems/AppBarToolbarItemsComponent.vue'
import LexonChronometerComponent from '@/components/LexonChronometer/LexonChronometerComponent.vue'
import LexonSearchFieldComponent from '@/components/LexonSearchField/LexonSearchFieldComponent.vue'
import LefebvreLogoComponent from '@/components/Logo/LefebvreLogoComponent.vue'
import { Getter, Mutation } from 'vuex-class'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { SearchTab } from '@/store/modules/tabs/tabsTypes'
import PermissionsMixin from '@/mixins/PermissionsMixin.vue'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'
import { imageURL } from '@/assets/images/url/imageURL'

const tabsModule = ModuleNamespaces.TABS
const authModule = ModuleNamespaces.AUTH

@Component({
  components: {
    AppBarToolbarItemsComponent,
    LexonChronometerComponent,
    LexonSearchFieldComponent,
    LefebvreLogoComponent
  }
})
export default class AppBarComponent extends Mixins(PermissionsMixin) {
  @Prop({
    type: Number
  })
  windowWidth!: number

  @Mutation('SET_CURRENT_SEARCH_TAB_INFO', { namespace: tabsModule }) setCurrentTabInfo: ({}) => void

  @Getter('getCurrentSearchTabInfo', { namespace: tabsModule }) searchViewTabInfo: SearchTab
  @Getter('getIsPortalUser', { namespace: authModule }) isPortalUser: boolean

  get showSearchSection(): boolean {
    return !this.isPortalUser;
  }

  get logoRouteName(): string {
    return this.isPortalUser ? URLS.EXPEDIENTS : URLS.DASHBOARD
  }

  get checkIfIsTablet(): boolean {
    return this.windowWidth <= 768
  }

  get calculateHeight(): number {
    return this.checkIfIsTablet ? 132 : 76
  }

  get renderedLogo() {
    return imageURL.logo
  }

  onSearchTerm(searchTerm: string) {
    trackEvent(TrackerEvents.SEARCH)
    this.setCurrentTabInfo({ name: '', index: 0 })
    this.$router.push({
      name: URLS.SEARCH,
      params: {
        searchTerm
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.app-bar {
  background-color: $neutral-white-000 !important;

  &.v-app-bar.v-app-bar--fixed {
    z-index: 9;
  }

  ::v-deep .v-toolbar__content {
    width: 100%;
    box-shadow: $shadow-md;
    padding: 0;
  }

  .tablet-header {
    display: flex;
    justify-content: space-between;
    height: calc(#{$app-bar-height} - 20px);
    margin-left: 4px;
  }

  .app-bar-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: $app-bar-height;
    background-color: $neutral-white-000;
    padding: $spacing-sm $spacing-xl;
  }

  .search-section {
    @include flex($justify-content: flex-end);
    max-width: 660px;
    color: $corporate-color;
  }
}

@include untilTablet {
  .app-bar {
    ::v-deep .v-toolbar__content {
      display: block;
      border: none;
    }
  }
}

@include tabletAndMore {
  .app-bar {
    .drawer-trigger {
      padding-left: 17px;
    }
  }
}

@include desktopLarge {
  .app-bar {
    .other-links {
      margin: 0 17px 0 40px;
    }
  }
}
</style>
